import makeApi from "../../libs/axios/api";
import { type LabelCatalog } from "../../types/labelCatalog";
const apiPromise = makeApi();

const getLabelCatalogData = async (
  partNumbers: string[]
): Promise<LabelCatalog[]> => {
  const api = await apiPromise;
  const storedData = localStorage.getItem("customerInfo");
  const customerInfo = storedData ? JSON.parse(storedData) : {};

  const accountNo = customerInfo.customerAccountNumber;
  const companyCode = customerInfo?.countryCode;
  const params = new URLSearchParams();
  partNumbers.forEach((part) => params.append("partNumbers", part));

  const path = `/labelcatalog/${accountNo}/${companyCode}?${params.toString()}`;
  return api.get(path).then((response) => {
    return response.data;
  });
};
export default getLabelCatalogData;
